import { SET_TALENT_INFO_VCARD, CLEAR_TALENT_INFO_VCARD } from '../constants';

//Obtiene toda la informacion relacionada a un talento para mostrarla en la pagina de talentos
export const setTalentInfoFromVcard = talentVcard => (dispatch, getState) => {
  dispatch({
    type: SET_TALENT_INFO_VCARD,
    payload: {
      id: talentVcard.id,
      internalIds: talentVcard.internalId,
      name: `${talentVcard.first_name} ${
        talentVcard.last_name !== null ? talentVcard.last_name : ''
      }`,
      roles: talentVcard.type,
    },
  });
};

//Purga la informacion del talento
export const clearTalentInfo = () => dispatch => {
  dispatch({
    type: CLEAR_TALENT_INFO_VCARD,
  });
};
